import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Lagenhet = lazy(() => import("@/pages/elavtal/Lagenhet"));

export const Route = createFileRoute("/elavtal/lagenhet")({
  head: () => seoHead("/elavtal/lagenhet"),
  component: () => <Lagenhet />,
});
